const NotFound = () => {

  return (
    <>
      <h1>
        Page not found
      </h1>
      <div>Use the nav bar above to head back to the projects page.</div>
    </>
  )

}

export default NotFound
